(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    const boot = () => root.document.querySelectorAll('[data-order-request]').forEach(api.mount);
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot); else boot();
    root.document.addEventListener('shopify:section:load', boot);
  }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const statuses = ['Request received', 'Awaiting your response', 'Under review', 'Closed', 'Resolved'];
  function proxyPath(value) {
    const path = (value || '/apps/eliteerp-contact').replace(/\/$/, '');
    if (!/^\/apps\/[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*$/.test(path)) throw Error('The support form is not configured. Please contact customer support.');
    return path + '/complaints';
  }
  function identity(values) {
    const number = String(values.order_number || '').trim().replace(/^#/, '');
    const phone = String(values.contact_no || '').trim();
    if (!/^\d{1,10}$/.test(number) || +number < 1 || +number > 2147483647) throw Error('Enter a valid order number.');
    if (phone.length > 50 || !/^[+()\d\s-]+$/.test(phone) || phone.replace(/\D/g, '').length < 7 || phone.replace(/\D/g, '').length > 17) throw Error('Enter the original order phone number, including its country code.');
    return Object.freeze({order_number: +number, contact_no: phone});
  }
  function maximum(item, type) { return Math.floor(Number(item[({1:'complaint_quantity', 2:'exchange_quantity', 3:'cancellation_quantity'})[type]]) || 0); }
  function selection(items, quantities, type) {
    if (![1,2,3].includes(type)) throw Error('Choose a request type.');
    const selected = [];
    items.forEach(item => {
      const raw = quantities[item.order_detail_id];
      const qty = raw === '' || raw == null ? 0 : Number(raw);
      if (!Number.isInteger(qty)) throw Error('Enter whole numbers only for requested quantities.');
      if (qty < 0 || qty > maximum(item,type)) throw Error('Enter an eligible quantity for each selected item.');
      if (qty > 0) selected.push({order_detail_id:item.order_detail_id, shipment_id:item.shipment_id, shipment_branch_id:item.shipment_branch_id, quantity:qty});
    });
    if (!selected.length || selected.length > 100) throw Error('Select at least one eligible item (maximum 100).');
    return selected;
  }
  function verifiedData(data) {
    if (!data || typeof data.already_existed !== 'boolean' || !Number.isInteger(data.order_number)) throw Error('The order response was incomplete. Please check again.');
    if (data.already_existed || data.reference) {
      if (!Number.isInteger(data.complaint_id) || data.complaint_id < 1 || !/^REQ-\d+-\d+-\d+$/.test(data.reference) || !statuses.includes(data.status) || !/^\d{4}-\d{2}-\d{2}$/.test(data.registered_on) || !['Complaint','Exchange','Cancellation','Customer request'].includes(data.type)) throw Error('The request status could not be confirmed. Please check again.');
    } else {
      if (!Array.isArray(data.items) || !Array.isArray(data.categories)) throw Error('The order items could not be loaded.');
      const ids = new Set();
      data.items.forEach(item => {
        if (!Number.isInteger(item.order_detail_id) || item.order_detail_id < 1 || ids.has(item.order_detail_id) || typeof item.name !== 'string' || typeof item.shipment !== 'string' || typeof item.status !== 'string' ||
            ![item.shipment_id,item.shipment_branch_id].every(x => x === null || (Number.isInteger(x) && x > 0)) || (item.shipment_id === null) !== (item.shipment_branch_id === null) ||
            !['ordered_quantity','returned_quantity','complaint_quantity','exchange_quantity','cancellation_quantity'].every(key => typeof item[key] === 'number' && Number.isFinite(item[key]) && item[key] >= 0)) throw Error('The order items could not be confirmed.');
        ids.add(item.order_detail_id);
      });
      if (!data.categories.every(c => Number.isInteger(c.id) && c.id > 0 && [1,2,3].includes(c.type_id) && typeof c.name === 'string')) throw Error('The request reasons could not be loaded.');
    }
    return data;
  }
  function retrySeconds(header, bodySeconds, now = Date.now()) {
    let seconds = NaN;
    if (typeof header === 'string' && /^\d+$/.test(header.trim())) seconds = Number(header.trim());
    else if (typeof header === 'string' && /GMT$/i.test(header.trim())) seconds = (Date.parse(header) - now) / 1000;
    if (!(seconds > 0) && /^(?:\d+)(?:\.\d+)?$/.test(String(bodySeconds))) seconds = Number(bodySeconds);
    return seconds > 0 && Number.isFinite(seconds) ? Math.min(86400, Math.ceil(seconds)) : 60;
  }
  function retryMessage(kind, seconds) {
    const time = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
    return 'Please wait ' + time + ' before ' + (kind === 'lookup' ? 'checking your order again' : 'registering a request again') + ', or contact support.';
  }
  function retryCooldown(clock = Date.now) {
    const until = {lookup:0, submit:0};
    return {
      start(kind, seconds) { until[kind] = Math.max(until[kind], clock() + seconds * 1000); },
      remaining(kind) { return Math.max(0, Math.ceil((until[kind] - clock()) / 1000)); }
    };
  }
  async function post(url, payload, fetcher, timeoutMs = 20000) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetcher(url,{method:'POST', credentials:'same-origin', cache:'no-store', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload), signal:controller.signal});
      let body;
      try { body = await response.json(); } catch (error) {
        if (response.ok) throw error;
        body = {};
      }
      body = body || {};
      if (!response.ok || body.success !== true) {
        const error = Error(response.status === 429 ? 'Too many attempts. Please wait before checking again, or contact support.' : response.status >= 500 ? 'We could not complete this check. Please try again later or contact support.' : (body.message || 'Please check your details and try again.'));
        error.status = response.status;
        if (response.status === 429) error.retryAfterSeconds = retrySeconds(response.headers?.get('Retry-After'), body.retry_after_seconds);
        throw error;
      }
      return verifiedData(body.data);
    } finally { clearTimeout(timeout); }
  }
  function mount(element) {
    if (element.dataset.requestMounted) return;
    element.dataset.requestMounted = 'true';
    const $ = selector => element.querySelector(selector);
    const verifyForm = $('[data-verify-form]'), requestForm = $('[data-request-form]'), feedback = $('[data-feedback]');
    const verifyFields = $('[data-identity-fields]'), requestFields = $('[data-request-fields]');
    const receipt = $('[data-receipt]'), check = $('[data-check]'), reset = $('[data-reset]'), submit = $('[data-submit-button]');
    const typeInput = requestForm.elements.complaint_type_id, categoryInput = requestForm.elements.complaint_category_id;
    let verified = null, data = null, busy = false, uncertain = false, route;
    const cooldown = retryCooldown();
    let countdownTimer = null, countdownKind = null;
    const say = message => { countdownKind=null; feedback.setAttribute('aria-live','polite'); feedback.textContent = message; if (message) feedback.focus(); };
    const busyState = value => {
      busy=value;
      verifyFields.disabled=value||cooldown.remaining('lookup')>0;
      requestFields.disabled=value||uncertain||cooldown.remaining('submit')>0;
      check.disabled=value||cooldown.remaining('lookup')>0;
      reset.disabled=value;
      element.setAttribute('aria-busy', String(value));
    };
    function tickCountdown() {
      if (!element.isConnected) { clearInterval(countdownTimer); countdownTimer=null; return; }
      busyState(busy);
      if (countdownKind && !busy) {
        const seconds=cooldown.remaining(countdownKind);
        if (seconds>0) feedback.textContent=retryMessage(countdownKind,seconds);
        else say('You can try again now. Your form details have been kept.');
      }
      if (!cooldown.remaining('lookup') && !cooldown.remaining('submit')) { clearInterval(countdownTimer); countdownTimer=null; }
    }
    function startCountdown(error,kind) {
      cooldown.start(kind,error.retryAfterSeconds||60);
      say(retryMessage(kind,cooldown.remaining(kind)));
      // Avoid announcing the timer every second to screen readers.
      feedback.setAttribute('aria-live','off');
      countdownKind=kind;
      if (countdownTimer===null) countdownTimer=setInterval(tickCountdown,1000);
    }
    function renderReceipt(result) {
      verifyForm.hidden=true; requestForm.hidden=true; receipt.hidden=false; check.hidden=false; reset.hidden=false;
      $('[data-receipt-label]').textContent=result.already_existed ? 'ALREADY REGISTERED' : 'REQUEST RECEIVED';
      $('[data-receipt-title]').textContent=result.status;
      $('[data-receipt-message]').textContent=result.already_existed ? 'A request already exists for this order. Your original case is being kept under the reference below.' : 'Thank you. Your request has been registered for review by our support team.';
      const details=$('[data-receipt-details]'); details.replaceChildren();
      [['Reference',result.reference],['Order','#'+result.order_number],['Request',result.type],['Registered',result.registered_on]].forEach(([label,value])=>{
        const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;details.append(dt,dd);
      });
      receipt.focus();
    }
    function renderItems() {
      const type=+typeInput.value, box=$('[data-items]');box.replaceChildren();
      const options=data.categories.filter(c=>c.type_id===type);
      categoryInput.replaceChildren(new Option(type ? 'Choose a reason' : 'Choose a type first',''));
      options.forEach(c=>categoryInput.add(new Option(c.name,String(c.id)))); categoryInput.disabled=!type;
      let eligible=false;
      data.items.forEach(item=>{
        const max=maximum(item,type), card=document.createElement('div'), description=document.createElement('div'), title=document.createElement('h3'), meta=document.createElement('p'), status=document.createElement('p'), limit=document.createElement('p'), label=document.createElement('label'), input=document.createElement('input');
        eligible=eligible||max>0; card.className='request-item';title.textContent=item.name;
        meta.textContent=(item.sku ? item.sku+' · ' : '')+item.shipment+' · Ordered: '+item.ordered_quantity;
        status.textContent=item.status+(item.returned_quantity ? ' · Returned: '+item.returned_quantity : '');
        limit.className='request-max';limit.textContent=type ? 'Eligible quantity: '+max : 'Choose a request type';
        label.textContent='Quantity';input.type='number';input.min='0';input.max=String(max);input.step='1';input.inputMode='numeric';input.value='0';input.disabled=max<=0;input.dataset.detail=String(item.order_detail_id);input.setAttribute('aria-label','Requested whole-number quantity for '+item.name);label.append(input);description.append(title,meta,status,limit);card.append(description,label);box.append(card);
      });
      submit.disabled=!eligible||!options.length;
      $('[data-eligibility-note]').textContent=!type ? 'Choose a request type to see eligible quantities.' : !eligible ? 'No items are eligible for this request type right now. Please contact support for help, including items still in transit.' : type===3 ? 'Only quantities not dispatched can be requested for cancellation. Booked shipments require support review.' : 'Choose from the delivered quantities below. Quantities already returned are excluded.';
    }
    async function verifyCurrent() {
      if (busy || !verified || cooldown.remaining('lookup')>0) return;
      say('');busyState(true);let showItems=false;
      try {
        const result=await post(route+'/verify',verified,window.fetch.bind(window));
        if (result.order_number!==verified.order_number) throw Error('The order response could not be confirmed.');
        data=result;uncertain=false;
        if(result.already_existed) renderReceipt(result);
        else {
          receipt.hidden=true;verifyForm.hidden=true;requestForm.hidden=false;check.hidden=false;reset.hidden=false;
          $('[data-order-heading]').textContent='Select items for order #'+result.order_number;
          typeInput.value='';renderItems();showItems=true;
        }
      } catch(error) {
        if(error.status===429)startCountdown(error,'lookup');
        else say(error.status ? error.message : 'We could not verify this check. Please try again or contact support.');
      }
      finally { busyState(false); if(uncertain) requestFields.disabled=true; if(showItems)typeInput.focus(); }
    }
    try {route=proxyPath(element.dataset.proxyPath);} catch(error) {say(error.message);verifyFields.disabled=true;return;}
    verifyForm.addEventListener('submit',event=>{
      event.preventDefault();if(busy||cooldown.remaining('lookup')>0)return;
      try {verified=identity(Object.fromEntries(new FormData(verifyForm)));verifyCurrent();}catch(error){say(error.message);}
    });
    typeInput.addEventListener('change',()=>{if(data&&!busy)renderItems();});
    check.addEventListener('click',verifyCurrent);
    reset.addEventListener('click',()=>{if(busy)return;verified=null;data=null;uncertain=false;verifyForm.reset();requestForm.reset();receipt.hidden=true;requestForm.hidden=true;verifyForm.hidden=false;check.hidden=true;reset.hidden=true;say('');busyState(false);if(cooldown.remaining('lookup')>0)startCountdown({retryAfterSeconds:cooldown.remaining('lookup')},'lookup');else verifyForm.elements.order_number.focus();});
    requestForm.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||uncertain||!verified||!data||cooldown.remaining('submit')>0)return;
      let payload;
      try {
        const type=+typeInput.value, category=+categoryInput.value, remarks=requestForm.elements.remarks.value.trim();
        if(!data.categories.some(c=>c.id===category&&c.type_id===type))throw Error('Choose a reason for the selected request type.');
        if(!remarks||remarks.length>500)throw Error('Describe your concern in up to 500 characters.');
        const quantities={};element.querySelectorAll('[data-detail]').forEach(input=>{quantities[input.dataset.detail]=input.value;});
        payload={...verified,complaint_type_id:type,complaint_category_id:category,remarks,items:selection(data.items,quantities,type),website:requestForm.elements.website.value};
      } catch(error) {say(error.message);return;}
      say('');busyState(true);
      try {
        const result=await post(route,payload,window.fetch.bind(window));
        if(!result.reference||result.order_number!==verified.order_number)throw Error('Registration was not confirmed.');
        renderReceipt(result);
      } catch(error) {
        uncertain=!error.status||error.status>=500;
        if(error.status===429)startCountdown(error,'submit');
        else say(uncertain ? 'We could not confirm whether your request was saved. Use CHECK REQUEST STATUS before trying again.' : error.message);
        check.hidden=false;
      } finally {busyState(false);if(uncertain)requestFields.disabled=true;}
    });
  }
  return {proxyPath,identity,maximum,selection,verifiedData,retrySeconds,retryMessage,retryCooldown,post,mount};
});
